function PlanGroupProdSubclassCell(props) {
    return (
        <>
            {props.value?.product_h11?.map((obj) => obj.label).join(",") ?? "-"}
        </>
    );
}

export default PlanGroupProdSubclassCell;
